export default "__VITE_ASSET__CG$F6IyV__"